// Day labels for thread dividers (Discussions). Pure, so the calendar math
// — the part that misfiles a message under the wrong day — is testable.

/** "Today" / "Yesterday" / "Aug 24" / "Aug 24, 2025" (other years). */
export function dayLabel(at: number, now: number): string {
  const d = new Date(at);
  const ref = new Date(now);
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOf(ref) - startOf(d)) / 86_400_000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (d.getFullYear() === ref.getFullYear()) {
    return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  }
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}

/** True when two timestamps fall on different calendar days. */
export function crossesDay(a: number, b: number): boolean {
  const x = new Date(a);
  const y = new Date(b);
  return (
    x.getFullYear() !== y.getFullYear() ||
    x.getMonth() !== y.getMonth() ||
    x.getDate() !== y.getDate()
  );
}
